module.exports = __webpack_public_path__ + "static/media/biocertica-logo-only-colour.2d58b395.svg";